<template>
  <b-form @submit.prevent="onSearch">
    <b-input-group class="mb-3 w-100 searcher">
      <b-form-input v-mask="searcherMask" v-model="search.term" :placeholder="searcherPlaceholder"></b-form-input>
      <b-input-group-append>
        <b-button variant="outline-info searcher-options" v-b-toggle.searcher-options>
          <i class="mdi mdi-dots-vertical"></i>
        </b-button>
        <b-button variant="info" type="submit">
          <span><i class="d-block d-sm-none mdi mdi-magnify"></i></span>
          <span class="d-none d-sm-block">Buscar</span>
        </b-button>
        <b-button v-if="!hideFilters" variant="outline-primary" @click="$emit('toggleFilters')">
          <i class="mdi mdi-filter-outline"></i>
        </b-button>
        <b-button v-if="mode !== 'box' && enableCsvExport" variant="outline-primary" @click="$emit('generateCsv')">csv</b-button>
      </b-input-group-append>
    </b-input-group>
    <b-collapse id="searcher-options" class="mt-2">
    <b-card>
      <b-form-checkbox-group
        v-model="checksOptions"
        @input="onChange"
        :options="searcherOptions"
      ></b-form-checkbox-group>
      <lm-button-v2 class="mt-3 d-block" @click="toggleSearcherOptions()">{{ textButtonToggleSearcherOptions }}</lm-button-v2>
      <div class="text-italic mt-2 text-info" v-if="!search.fields.length">Si no seleccionas ninguna opcion, se buscará en todas.</div>
    </b-card>
  </b-collapse>
  </b-form>
</template>

<script>
import LmButtonV2 from '@/components/form/elements/LmButtonV2'
export default {
  components: {
    LmButtonV2
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    hideFilters: {
      type: Boolean,
      required: true
    },
    mode: {
      type: String
    },
    enableCsvExport: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    options: {
      immediate: true,
      handler (val) {
        const hasPredefinedSelected = val.some(objeto => objeto.selected !== undefined && objeto.selected !== null)

        if (hasPredefinedSelected) {
          val.forEach((el, index) => {
            if (el.selected) {
              this.checksOptions.push(index)
            }
          })
        } else {
          this.checksOptions = val.map((el, index) => index)
        }

        this.onChange(this.checksOptions)
      }
    }
  },
  computed: {
    searcherOptions () {
      return this.options.map((el, index) => {
        return {
          text: el.label,
          value: index
        }
      })
    },

    searcherMask () {
      const independentWordSearch = this.options.find(i => i?.independent_word_search)
      return independentWordSearch?.input_search_mask || null
    },

    searcherPlaceholder () {
      const independentWordSearch = this.options.find(i => i?.independent_word_search)
      return independentWordSearch?.input_search_placeholder || 'Buscar...'
    },

    textButtonToggleSearcherOptions () {
      if (this.checksOptions.length > 0) {
        return 'Limpiar Opciones'
      } else {
        return 'Seleccionar Todo'
      }
    }
  },
  data () {
    return {
      checksOptions: [],
      search: {
        term: '',
        fields: []
      }
    }
  },
  methods: {
    onChange (event) {
      const fields = []
      for (const index of event) {
        const check = this.options.at(index).key
        fields.push(check)
      }
      this.search.fields = fields.flat()
    },
    onSearch () {
      this.$emit('onSearch', this.search)
    },
    toggleSearcherOptions () {
      if (this.checksOptions.length > 0) {
        this.checksOptions = []
      } else {
        this.checksOptions = this.options.map((el, index) => index)
      }
    }
  }
}
</script>

<style lang="sass" scoped>
  .searcher .input-group-append .btn
    padding: 0 1rem
    &.searcher-options
      padding: 0 .2rem
      &.collapsed
        background-color: white
        color: #17a2b8
    i
      font-size: 1.4rem
    &:focus
      box-shadow: initial
</style>
